var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackageImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 470,
    height: 270,
    viewBox: "0 0 470 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-835 -664) translate(835 664)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M0 0h255c8.284 0 15 6.716 15 15v219H15c-8.284 0-15-6.716-15-15V0z",
    transform: "translate(0 35)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M45.115 15.923L90.231 69 0 69z",
    transform: "translate(0 35) translate(66 72)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M91.558 0L138 69 45.115 69z",
    transform: "translate(0 35) translate(66 72)"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 469,
    height: 269,
    x: 0.5,
    y: 0.5,
    stroke: "#B6B6B6",
    rx: 15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6B6B6",
    d: "M112 10H358V23H112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M295 46H387V59H295zM295 86H377V99H295zM296 124H394V137H296z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 11,
    x: 416.5,
    y: 10.5,
    fill: "#D8D8D8",
    stroke: "#979797",
    rx: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 25,
    x: 295.167,
    y: 229.5,
    fill: "#D8D8D8",
    stroke: "#979797",
    rx: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9C9C9",
    strokeLinecap: "square",
    strokeWidth: 0.3,
    d: "M295.5 76.5L455.5 76.5M296.5 114.5L456.5 114.5M296.5 216.5L456.5 216.5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageImage);
export default __webpack_public_path__ + "static/media/package-image.b442cf4d2790e7b87d4aa50d60229b94.svg";
export { ForwardRef as ReactComponent };